// 提前对接客户信息列表

<template>
  <div class="threeLevelMain">
    <!-- 头部查询区域 -->
    <div class="queryBox clearfix">
      <div class="query_row" v-show="!isFoldQuery">
        <div class="scan_box">
          <span class="sp_scan">公司名称：</span>
          <el-input
            class="ip_uniform_style"
            @input="searchBtn"
            v-model="getTabData.corporate_name"
            placeholder="全部"
            size="mini"
          ></el-input>
        </div>
        <div class="scan_box">
          <span class="sp_scan">品牌名称：</span>
          <el-input
            class="ip_uniform_style"
            @input="searchBtn"
            v-model="getTabData.brand_name"
            placeholder="请输入品牌"
            size="mini"
          ></el-input>
        </div>
        <div class="scan_box">
          <span class="sp_scan">合作性质：</span>
          <el-select
            clearable
            v-model="getTabData.properties"
            @change="searchBtn('due')"
            placeholder="全部"
            size="mini"
            class="ip_uniform_style"
          >
            <el-option
              v-for="item in khlxOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="block scan_box">
          <span class="sp_scan">签订时间：</span>
          <el-date-picker
            v-model="valueDate"
            :editable="false"
            type="monthrange"
            class="date_range"
            align="right"
            unlink-panels
            range-separator="-"
            size="mini"
            value-format="yyyy-MM-dd"
            @change="searchBtn('contact')"
            :picker-options="monthPickerOptions"
          >
          </el-date-picker>
        </div>

        <div class="block scan_box">
          <span class="sp_scan">到期时间：</span>
          <el-date-picker
            v-model="dqsjDate"
            :editable="false"
            class="date_range"
            type="monthrange"
            align="right"
            unlink-panels
            range-separator="-"
            size="mini"
            value-format="yyyy-MM-dd"
            @change="searchBtn('due')"
            :picker-options="monthPickerOptions"
          >
          </el-date-picker>
        </div>

        <div class="scan_box">
          <span class="sp_scan">运营分部：</span>
          <el-select
            clearable
            @change="searchBtn"
            v-model="getTabData.group"
            placeholder="全部"
            size="mini"
            class="ip_uniform_style"
          >
            <el-option
              v-for="item in operationDepartmentOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="scan_box">
          <span class="sp_scan">店长：</span>
          <el-select
            clearable
            v-model="getTabData.assign_id"
            @change="searchBtn('due')"
            placeholder="全部"
            size="mini"
            filterable
            class="ip_uniform_style"
          >
            <el-option
              v-for="item in operatePersonOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div class="scan_box">
          <span class="sp_scan">组长：</span>
          <el-select
            clearable
            v-model="getTabData.assign_name_leader"
            @change="searchBtn('due')"
            placeholder="全部"
            size="mini"
            filterable
            class="ip_uniform_style"
          >
            <el-option
              v-for="item in groupLeaderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div class="scan_box">
          <span class="sp_scan">类目：</span>
          <el-select
            clearable
            v-model="getTabData.category"
            @change="searchBtn('due')"
            placeholder="全部"
            size="mini"
            class="ip_uniform_style"
          >
            <el-option
              v-for="item in categoryOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="scan_box">
          <span class="sp_scan" style="line-height:1;">实际服务金额：</span>
          <div class="cooperation_amount" style="margin-right: 10px;">
            <el-input
              class="ip_scan"
              @input="searchBtn"
              v-model="getTabData.contract_amount_state"
              placeholder=""
              size="mini"
              style="width:110px;"
            ></el-input>
            <span style="margin:0 10px;">~</span>
            <el-input
              class="ip_scan"
              @input="searchBtn"
              v-model="getTabData.contract_amount_end"
              placeholder=""
              size="mini"
              style="width:110px;"
            ></el-input>
          </div>
        </div>

        <div class="scan_box">
          <span class="sp_scan">销售：</span>
          <el-select
            clearable
            v-model="getTabData.sale_id"
            @change="searchBtn('due')"
            placeholder="全部"
            size="mini"
            filterable
            class="ip_uniform_style"
          >
            <el-option
              v-for="item in salePersonOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <!-- 购买人员用于查看所有客户信息（只读） -->
        <div class="scan_box" v-if="userId == '173'">
          <span class="sp_scan">查看状态：</span>
          <el-select
            v-model="getTabData.is_Purchase"
            @change="searchBtn"
            clearable
            size="mini"
            class="ip_uniform_style"
          >
            <el-option label="默认" value=""></el-option>
            <el-option label="所有客户信息（只读）" value="1"></el-option>
          </el-select>
        </div>
      </div>
      <div class="btn_area_out" v-show="!isFoldQuery">
        <!-- <el-button 
            size="mini" 
            @click="searchBtn">查询</el-button> -->
        <el-button
          size="mini"
          @click="resetSearch"
          type="primary"
          icon="el-icon-refresh"
          >重置筛选</el-button
        >
      </div>
      <!-- 折叠区域 -->
      <div class="fold_btn">
        <!-- 展开 -->
        <div
          class="f_open_area little_hands"
          @click="isFoldQuery = !isFoldQuery"
          v-show="!isFoldQuery"
        >
          <el-button
            type="text"
            icon="el-icon-arrow-up"
            class="btn_icon_s"
          ></el-button>
          <p class="fold_content">收起</p>
        </div>
        <!-- 折叠 -->
        <div class="f_fold_area" v-show="isFoldQuery">
          <h3>筛选区域</h3>
          <div
            class="f_f_content little_hands"
            @click="isFoldQuery = !isFoldQuery"
          >
            <p class="fold_content">展开</p>
            <el-button
              type="text"
              icon="el-icon-arrow-down"
              class="btn_icon_s"
            ></el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="account-view">
      <div class="ac-result">
        <span class="label">总金额：</span>
        <span class="cn_num">{{ zje || 0 }}</span>
      </div>
      <div class="ac-result">
        <span class="label">总数量：</span>
        <span class="cn_num">{{ zsl || 0 }}</span>
      </div>
    </div>

    <!-- 内容 -->
    <tablePageComp
      :columnsList="columnsList"
      :dataList="dataList"
      :orderNumConfig="{}"
      :getDataConfig="dataQueryFunc()"
      :updateDataSignObj="{
        updateDataTag,
        resetPageNum,
      }"
      @setResetPageNum="setRPN"
      :totalCount="totalCount"
      :recalculateTag="isFoldQuery"
    >
      <!-- 编号 -->
      <!-- 利用插槽 -->
      <el-table-column slot="id" width="75" align="center" label="客户编号">
        <template slot-scope="scope">
          <div>{{ scope.row.customer_id }}</div>
        </template>
      </el-table-column>

      <el-table-column
        slot="corporate_name"
        align="center"
        label="公司名称"
        width="120"
      >
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            @click="handleDetail(scope.row)"
            >{{ scope.row.corporate_name }}</el-link
          >
        </template>
      </el-table-column>

      <!-- 品牌名称 -->
      <el-table-column
        slot="brand_name"
        width="120"
        align="center"
        label="品牌名称"
      >
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            @click="handleDetail(scope.row)"
            >{{ scope.row.brand_name }}</el-link
          >
        </template>
      </el-table-column>

      <!-- 签订时间 -->
      <el-table-column
        slot="cooperation_time"
        width="100"
        align="center"
        label="签订时间"
        sortable
        prop="cooperation_time"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.cooperation_time.split(" ")[0] }}</div>
        </template>
      </el-table-column>

      <!-- 到期时间 -->
      <el-table-column
        slot="due_time"
        width="100"
        align="center"
        label="到期时间"
        sortable
        prop="due_time"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.due_time.split(" ")[0] }}</div>
        </template>
      </el-table-column>

      <!-- 合同金额 -->
      <el-table-column
        slot="contract_amount"
        width="100"
        align="center"
        label="合同金额"
        v-if="getTabData.is_Purchase == ''"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.contract_amount }}</div>
        </template>
      </el-table-column>

      <!-- 实际服务金额 -->
      <el-table-column
        slot="cooperation_amount"
        width="100"
        align="center"
        label="实际服务金额"
        v-if="getTabData.is_Purchase == ''"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.cooperation_amount }}</div>
        </template>
      </el-table-column>

      <el-table-column
        slot="properties"
        width="80"
        align="center"
        label="合作性质"
      >
        <template slot-scope="scope">
          <div class="fontColor_theme">
            {{
              scope.row.properties == 1
                ? "新签"
                : scope.row.properties == 2
                ? "续签"
                : scope.row.properties == 3
                ? "新签新增"
                : "续签新增"
            }}
          </div>
        </template>
      </el-table-column>

      <!-- 最近沟通时间 -->
      <el-table-column
        slot="touch_time"
        width="180"
        align="center"
        label="最近沟通时间"
        sortable
        prop="touch_time"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.touch_time == "" ? "未沟通" : scope.row.touch_time }}
          </div>
        </template>
      </el-table-column>

      <!-- 波罗蜜 -->
      <el-table-column
        slot="boluomi"
        width="100"
        align="center"
        label="波罗蜜"
        v-if="jurisdiction"
      >
        <template slot-scope="scope">
          {{ scope.row.boluomi }}
          <el-popover
            placement="top-start"
            width="200"
            trigger="click"
            :ref="`re-popover-${scope.$index}`"
          >
            <div>
              <el-input
                style="margin-bottom: 10px"
                v-model="scope.row.boluomi"
                size="mini"
                placeholder="请输入内容"
              ></el-input>
            </div>
            <div style="text-align: right; margin: 0">
              <!-- <el-button size="mini" type="text" @click="scope.row.boluomiVisible = false">取消</el-button> -->
              <el-button
                size="mini"
                type="text"
                @click="
                  scope._self.$refs[`re-popover-${scope.$index}`].doClose()
                "
                >取消</el-button
              >
              <el-button
                type="primary"
                size="mini"
                @click="remarkEditConfirm(scope.row, scope.$index)"
                >确定</el-button
              >
            </div>
            <!-- <i class="el-icon-edit" slot="reference" @click="remarkEditClick(scope.$index)"></i> -->
            <i class="el-icon-edit" slot="reference"></i>
          </el-popover>
        </template>
      </el-table-column>

      <!-- 详情 -->
      <el-table-column
        slot="info_detail"
        align="center"
        label="客户信息详情"
        width="105"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            class="tableBtn_width"
            type="success"
            plain
            size="mini"
            @click="handleDetail(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>

      <!-- 店长 -->
      <el-table-column
        slot="assign_name"
        width="60"
        align="center"
        label="店长"
      >
        <template slot-scope="scope">
          <!-- <div :class="scope.row.state == '0'?'fontColor_info':'fontColor_theme'" v-if="scope.row.state == '2' || scope.row.state == '3' ? false : true">
                  {{scope.row.state == '0' ? '未指派' : `${scope.row.name_post == '1' ? scope.row.name : '已指派'}`}}
                </div>
                <div v-if="scope.row.state == '2' ? true : false" class="fontColor_danger">
                  已拒绝
                </div>
                <div v-if="scope.row.state == '3' ? true : false" class="fontColor_danger">
                  已撤回
                </div> -->
          <div>{{ scope.row.assign_name }}</div>
        </template>
      </el-table-column>

      <el-table-column slot="group_name" width="60" align="center" label="组长">
        <template slot-scope="scope">
          <!-- <div :class="scope.row.state == '0'?'fontColor_info':'fontColor_theme'" v-if="scope.row.state == '2' || scope.row.state == '3' ? false : true">
                  {{scope.row.state == '0' ? '未指派' : `${scope.row.name_post == '4' || scope.row.name_post == '3'? scope.row.name : '已指派'}`}}
                </div>
                <div v-if="scope.row.state == '2' ? true : false" class="fontColor_danger">
                  已拒绝
                </div>
                <div v-if="scope.row.state == '3' ? true : false" class="fontColor_danger">
                  已撤回
                </div> -->
          <div>{{ scope.row.assign_name_leader }}</div>
        </template>
      </el-table-column>

      <el-table-column slot="sale_id" align="center" label="销售" width="60">
        <template slot-scope="scope">
          <div>{{ scope.row.sale_name }}</div>
        </template>
      </el-table-column>

      <el-table-column
        slot="viewable_person"
        width="200"
        align="center"
        label="相关销售"
      >
        <template slot-scope="scope">
          <!-- 最高权限或销售主管可设置 -->
          <div v-if="jurisdiction || $tools.sessionGetStore('post') == 7">
            <el-select
              v-model="scope.row.viewable_person"
              multiple
              collapse-tags
              placeholder="设置相关销售"
              @change="viewableHandle(scope.row)"
            >
              <el-option
                v-for="item in salePersonOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div v-else>
            {{ scope.row.viewable_name.join("、") }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        slot="is_contract"
        align="center"
        label="是否断约"
        width="50"
      >
        <template slot-scope="scope">
          <div
            :class="
              scope.row.is_contract == '1'
                ? 'fontColor_danger'
                : 'fontColor_theme'
            "
          >
            {{ scope.row.is_contract == "1" ? "是" : "否" }}
          </div>
        </template>
      </el-table-column>

      <el-table-column slot="incall" width="80" align="center" label="incall">
        <template slot-scope="scope">
          <div v-if="scope.row.incall == '1'" class="fontColor_success">是</div>
          <div v-if="scope.row.incall == '0'" class="fontColor_theme">否</div>
          <div v-if="scope.row.incall == ''" class="fontColor_info">未确定</div>
        </template>
      </el-table-column>

      <!-- 客户姓名 -->
      <!-- <el-table-column
            slot="customer_name"
            width="120"
            align="center"
            label="客户姓名"
        >
            <template slot-scope="scope">
                <div>{{scope.row.customer_name}}</div>
            </template>
        </el-table-column> -->
      <el-table-column
        slot="zhipai"
        align="center"
        label="指派操作"
        v-if="jurisdiction"
        width="105"
      >
        <template slot-scope="scope">
          <el-button
            class="tableBtn_width"
            type="warning"
            plain
            size="mini"
            @click="openAssignDia(scope.row)"
            >修改指派</el-button
          >
        </template>
      </el-table-column>

      <!-- 签约操作 -->
      <el-table-column
        slot="signUp"
        align="center"
        label="签约操作"
        width="105"
      >
        <template slot-scope="scope">
          <!-- <el-button class="tableBtn_width" type="warning" plain size="mini" @click="insertcontract(scope.row,'0','8')">签约</el-button> -->
          <el-button
            class="tableBtn_width"
            type="warning"
            plain
            size="mini"
            @click="openContractDia(scope.row)"
            >签约</el-button
          >
        </template>
      </el-table-column>

      <!-- 添加小记操作 -->
      <el-table-column
        slot="addBtn"
        align="center"
        label="销售沟通小记"
        width="105"
      >
        <template slot-scope="scope">
          <el-link type="success" @click="openDialog(scope.row, true)"
            >新建小记</el-link
          >
        </template>
      </el-table-column>

      <el-table-column
        v-if="jurisdiction"
        slot="kill_contract"
        align="center"
        label="断约操作"
        width="105"
      >
        <template slot-scope="scope">
          <el-button
            class="tableBtn_width"
            type="danger"
            plain
            size="mini"
            @click="openDYDialog(scope.row.customer_id)"
            >断约</el-button
          >
        </template>
      </el-table-column>
    </tablePageComp>

    <!-- 添加小记对话框 -->
    <el-dialog
      title="新建沟通小记"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="addClose"
    >
      <!-- 表单部分 -->
      <el-form
        :model="touchForm"
        :rules="touchRules"
        ref="touchForm"
        label-width="100px"
      >
        <el-form-item label="公司名称" prop="name">
          <el-input v-model="touchForm.name" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="公司编号" prop="id">
          <el-input v-model="touchForm.id" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="操作人" prop="user_name">
          <el-input v-model="touchForm.user_name" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="沟通小记" prop="contact_Records">
          <el-input v-model="touchForm.contact_Records"></el-input>
        </el-form-item>
        <el-form-item label="沟通方式" prop="contact_meth">
          <el-input v-model="touchForm.contact_meth"></el-input>
        </el-form-item>
        <el-form-item label="审核" prop="to_examine">
          <el-input v-model="touchForm.to_examine"></el-input>
        </el-form-item>
        <el-form-item label="投诉" prop="complaint">
          <el-input v-model="touchForm.complaint"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input
            type="textarea"
            :rows="2"
            v-model="touchForm.remarks"
          ></el-input>
        </el-form-item>
      </el-form>

      <!-- 弹出确认框 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTouchInfo('touchForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 指派客户对话框 -->
    <el-dialog
      title="修改指派"
      :visible.sync="assignVisible"
      width="500px"
      :before-close="assignClose"
    >
      <el-form
        :model="assignForm"
        ref="assignForm"
        label-width="100px"
        :show-message="false"
      >
        <!-- <el-form-item label="客户编号" prop="id">
            <el-input v-model.number="assignForm.id" disabled></el-input>
          </el-form-item> -->
        <el-form-item label="公司名称">
          <el-input
            v-model="assignForm.name"
            disabled
            class="commit_input_wd"
          ></el-input>
        </el-form-item>
        <el-form-item label="店长" prop="assign_id" required>
          <el-select
            v-model="assignForm.assign_id"
            clearable
            class="commit_input_wd"
            filterable
          >
            <el-option
              v-for="item in operatePersonOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="组长" required>
          <el-select
            v-model="assignForm.assign_id_leader"
            class="commit_input_wd"
            clearable
            filterable
          >
            <el-option
              v-for="item in groupLeaderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主管" prop="assign_id_supervisor" required>
          <el-select
            v-model="assignForm.assign_id_supervisor"
            class="commit_input_wd"
            clearable
            filterable
          >
            <el-option
              v-for="item in operateSuperOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="assignVisible = false">取 消</el-button>
        <el-button type="primary" @click="assignHandle('assignForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 签约信息对话框 -->
    <el-dialog
      title="正式签约申请"
      :visible.sync="baseInfoVisible"
      width="500px"
      :before-close="assignClose"
      center
    >
      <div class="t-c">
        <!-- <NewCustomer
          isNewAdd="4"
          :fatherGiveYou="contract_form"
          state="8"
          @completeView="subComplete"
        ></NewCustomer> -->
        <el-upload
          class="upload-contract"
          :action="$store.state.uploadUrl"
          :on-remove="handleRemoveBott"
          :before-upload="beforeUploadContract"
          :on-success="sucUploadBott"
          :file-list="backFileList"
          drag
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">
            请上传底单文件，且必须为JPG/PNG/PDF文件
          </div>
        </el-upload>
      </div>
      <span slot="footer">
        <el-button @click="subApplyForm" type="primary">提 交 申 请</el-button>
      </span>
    </el-dialog>

    <!-- 断约客户对话框 -->
    <el-dialog
      title="客户断约"
      :visible.sync="dyVisible"
      width="600px"
      :before-close="addClose"
    >
      <el-form
        class="form-main"
        label-width="80px"
        ref="dyFormRef"
        :model="formDYData"
        :rules="breakRules"
        size="small"
      >
        <el-form-item prop="is_refund">
          <el-radio-group v-model="formDYData.is_refund">
            <el-radio label="0" border>无退款</el-radio>
            <el-radio label="1" border>有退款</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="formDYData.is_refund == 1">
          <el-form-item prop="refund_time" label="退款时间">
            <el-date-picker
              v-model="formDYData.refund_time"
              type="date"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="refund_money" label="退款金额">
            <el-input v-model="formDYData.refund_money"> </el-input>
          </el-form-item>
          <el-form-item prop="refund_details" label="退款内容">
            <el-input
              v-model="formDYData.refund_details"
              type="textarea"
              placeholder="请填写退款内容"
              :rows="3"
            ></el-input>
          </el-form-item>
        </div>

        <el-form-item label="断约原因" prop="details">
          <el-input
            v-model="formDYData.details"
            type="textarea"
            placeholder="请填写断约原因"
            :rows="3"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dyVisible = false" :loading="btnLoading"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="insertcontract()"
          :loading="btnLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <DetailContract :detailConfig="detailConfig"></DetailContract>
  </div>
</template>

<script>
import api from "@/api";
import utils from "@/libs/utils.js";
import NewCustomer from "@/components/workOrder/newCustomer.vue";
import moment from "moment";
import options from "@/libs/common.js";
import { numberValidate } from "@/libs/validate.js";

export default {
  components: {
    NewCustomer,
  },
  data() {
    //   let currentPage = utils.sessionGetStore('currentPage')
    // let currentPage = 1//
    // currentPage = currentPage == null ? 1 : currentPage
    // console.log(typeof(currentPage))
    let testPhone = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入手机号"));
      } else if (!utils.isCellPhone(value)) {
        callback(new Error("请输入正确的手机号!"));
      } else {
        callback();
      }
    };
    return {
      isFoldQuery: false,
      monthPickerOptions: options.monthPickerOptions,
      btnState: false,
      // currentPage: Number(currentPage),
      valueDate: [], //签订日期区间
      dqsjDate: [], //到期时间区间
      cnOption: [
        {
          value: "",
          label: "全部",
        },
      ], //公司名选项

      //表格内容相关
      loading: false, //表格内容加载中
      dataList: [], //表格数据列表
      //列的数据 插槽站位
      columnsList: [
        // {
        //   label:'新建沟通小记',
        //   slotName:"addBtn"
        // },
        // {
        //     label:"编号",
        //     slotName:"id"
        // },
        {
          label: "公司名称",
          slotName: "corporate_name",
        },
        {
          label: "品牌名称",
          slotName: "brand_name",
        },
        {
          label: "签订时间",
          slotName: "cooperation_time",
        },
        {
          label: "到期时间",
          slotName: "due_time",
        },
        {
          label: "合同金额",
          slotName: "contract_amount",
        },
        {
          label: "实际服务金额",
          slotName: "cooperation_amount",
        },
        {
          label: "打款时间",
          prop: "payment_time",
          width: 100,
        },
        {
          label: "类目",
          prop: "category",
        },
        {
          label: "合作性质",
          slotName: "properties",
        },
        {
          label: "波罗蜜",
          slotName: "boluomi",
        },
        {
          label: "店长",
          slotName: "assign_name",
        },
        {
          label: "组长",
          slotName: "group_name",
        },
        {
          label: "运营主管",
          prop: "assign_name_supervisor",
        },
        {
          label: "销售",
          slotName: "sale_id",
        },
        {
          label: "相关销售",
          slotName: "viewable_person",
        },
        {
          label: "incall",
          slotName: "incall",
        },
        // {
        //   label:"是否断约",
        //   slotName:'is_contract'
        // },
        // {
        //   label: "最近沟通时间",
        //   slotName: "touch_time",
        // },
        // {
        //   label:'联系人',
        //   prop:'contacts'
        // },
        // {
        //   label:'职务',
        //   prop:'contacts_post'
        // },
        // {
        //   label:'联系人电话',
        //   prop:'contacts_phone',
        //   width:120
        // },
        // {
        //   label:"客户姓名",
        //   slotName:"customer_name"
        // },
        {
          label: "指派操作",
          slotName: "zhipai",
        },
        {
          label: "签约操作",
          slotName: "signUp",
        },
        // {
        //   label:"客户信息详情",
        //   slotName:"info_detail"
        // },

        {
          label: "断约操作",
          slotName: "kill_contract",
        },
      ],
      updateDataTag: false,
      resetPageNum: true, // 是否重置页面
      // 数据总条数
      totalCount: 0,
      userId: "", //用户id
      userName: "", //用户名
      getTabData: {
        start: "",
        end: "",
        corporate_name: "", //公司名 默认空
        due_time_start: "", //到期开始时间
        due_time_end: "", // 到期结束时间
        brand_name: "", // 品牌名
        assign_id: "", // 店长
        assign_name_leader: "", // 组长
        properties: "", // 客户类型
        contract_amount_state: "", // 合同金额区间开始
        contract_amount_end: "", // 合同金额结束
        category: "", //类目
        sale_id: "", //销售
        is_Purchase: "",
        group: "", //运营一部：静微、聂敏、小平；二部：灶丽、夏娇
      }, //表格数据查询条件

      // 客户类型选项
      khlxOption: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "新签",
        },
        {
          value: 2,
          label: "续签",
        },
      ],

      // 沟通小记数据
      dialogVisible: false, //新建沟通小记对话框是否显示
      touchForm: {
        complaint: "",
        id: "", //客户编号
        user_name: "", //操作人
        contact_Records: "", //沟通小记
        contact_meth: "", //沟通方式
        remarks: "", //备注
        to_examine: "", //审核
        complaint: "", //投诉
      },
      touchRules: {
        //验证规则
        contact_Records: [
          { required: true, message: "请填写沟通小记", trigger: "change" },
        ],
        contact_meth: [
          { required: true, message: "请填写沟通方式", trigger: "change" },
        ],
        complaint: [],
        id: [],
        user_name: [],
        remarks: [],
        to_examine: [],
        complaint: [],
      },

      // 指派客户
      assignVisible: false, // 对话框显示
      assignForm: {
        // 指派客户表单
        id: "", // 单条编号
        work_order_id: "", // 所属工单id
        assign_id: "", //被指派店长id
        name: "", //公司名称
        assign_id_leader: "", // 指派组长id
        assign_id_supervisor: "",
      },
      assignRules: {
        //验证规则
        id: [
          { required: true, message: "请填写客户编号", trigger: "change" },
          { type: "number", message: "客户编号必须为数字" },
        ],
        assign_id: [
          { required: true, message: "请选择店长", trigger: "change" },
        ],
      },
      jurisdiction: true, //权限 0:true    1,2:false
      department: utils.sessionGetStore("department"),

      zje: "", //总金额
      zsl: "", //总数量
      // 签约相关
      baseInfoVisible: false,
      contract_form: {}, // 表单信息

      // 断约相关
      // 断约相关
      formDYData: {
        details: "", // 断约原因
        is_refund: "0", //是否退款（0否1是）
        refund_time: "", //退款时间
        refund_money: "", //退款金额
        refund_details: "", //退款内容
      },
      breakRules: {
        refund_money: [
          {
            required: true,
            validator: numberValidate,
            trigger: "blur",
          },
        ],
        details: [
          { required: true, message: "请填写断约原因", trigger: "blur" },
        ],
        refund_time: [
          { required: true, message: "请选择退款时间", trigger: "change" },
        ],
        refund_details: [
          { required: true, message: "请填写退款内容", trigger: "blur" },
        ],
      },
      dyVisible: false, // 断约弹窗显示状态
      dyComtomer_id: "", // 断约客户id
      btnLoading: false,

      // 签约-底单
      backFile: "",
      backFileList: [], // 已上传文件列表

      // 详情查看
      detailConfig: {
        showSign: 0,
        contractProp: null,
      },
    };
  },
  watch: {},
  computed: {
    // 运营主管
    operateSuperOptions() {
      let leader = this.$store.state.leaderOptions.filter(
        (item) => item.value == "4"
      )[0].options;
      return [
        ...leader.filter((item) => item.post == "10"),
        { label: "龚蕾", value: "2" },
      ];
    },
    salePersonOptions() {
      return this.$store.getters.salePersonOptions;
    },
    groupLeaderOptions() {
      return this.$store.getters.groupLeaderOptions;
    },
    operatePersonOptions() {
      return this.$store.getters.operatePersonOptions;
    },
    categoryOptions() {
      return this.$store.getters.categoryOptions;
    },
    operationDepartmentOptions() {
      return this.$store.state.commonOptions.operationDepartmentOptions;
    },
  },
  methods: {
    // 设置相关销售
    viewableHandle(val) {
      let paramObj = {
        customer_id: val.customer_id,
        viewable_person: val.viewable_person.join(","),
      };
      this.$tools.debounceFunc(() => {
        this.$api
          .updateViewablePerson(paramObj)
          .then((_) => {
            this.updateDataTag = !this.updateDataTag;
            this.resetPageNum = false;
          })
          .catch((error) => {
            console.log(error);
            this.$message.error("设置相关销售失败了");
          });
      }, 500);
    },
    // 更新状态
    setRPN(e) {
      this.resetPageNum = e;
    },

    // 断约相关
    // 开启断约弹框
    openDYDialog(id) {
      this.dyComtomer_id = id;
      this.dyVisible = true;
    },
    // 客户断约状态操作 is_contract----- 1 断约   2 特批  0 签约
    insertcontract() {
      this.$refs.dyFormRef.validate((valid) => {
        if (valid) {
          let paramObj = {
            id: this.dyComtomer_id,
            is_contract: "1",
            ...this.formDYData,
          };
          this.btnLoading = true;
          api
            .breakContract(paramObj)
            .then((res) => {
              // console.log(res)
              if (res.data.code == 0) {
                utils.notificationInfo("提示", "该客户已设置为断约", "success");
                // 更新
                this.updateDataTag = !this.updateDataTag;

                this.resetPageNum = false;

                this.dyVisible = false;
                Object.keys(this.formDYData).forEach((key) => {
                  if (key == "is_refund") {
                    this.formDYData[key] = "0";
                  } else {
                    this.formDYData[key] = "";
                  }
                });
                this.dyComtomer_id = "";
              }
            })
            .catch((error) => {
              console.log(error);
              utils.notificationInfo("提示", "设置断约状态失败", "warning");
            })
            .finally(() => (this.btnLoading = false));
        }
      });
    },

    // 签约相关
    // 打开签约对话框
    openContractDia(data) {
      if (
        !data.assign_id ||
        !data.assign_id_leader ||
        !data.assign_id_supervisor
      ) {
        this.$message.error("请先完善指派信息,再进行操作");
        return;
      }
      // 初始化
      this.contract_form = {};
      this.baseInfoVisible = true;
      Object.keys(data).forEach((item) => {
        this.contract_form[item] = data[item];
      });

      // 导入指派人员信息
      // this.contract_form.assignInfo = {
      //   assign_id: data.assign_id,
      //   assign_id_leader: data.assign_id_leader,
      //   assign_id_supervisor: data.assign_id_supervisor,
      // };
    },
    subApplyForm() {
      if (this.contract_form.back_file === "") {
        this.$message.error("请上传底单文件");
        return;
      }
      // console.log("=======", this.contract_form);
      let paramObj = {};
      Object.keys(this.contract_form).forEach((key) => {
        if (this.contract_form[key]) {
          paramObj[key] = this.contract_form[key];
        }
      });
      paramObj.state = "8"; // 提前对接转签约工单
      paramObj.is_contract = "0"; // 签约客户标识
      this.btnLoading = true;
      this.$api
        .szAndTdContractFunc(paramObj)
        .then((res) => {
          // console.log(res);
          this.baseInfoVisible = false;
          this.$notify.success({
            title: "消息",
            message: "签约申请已提交",
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },

    // 底单文件上传处理
    beforeUploadContract(file) {
      let isJPG = file.type === "image/jpeg",
        isPNG = file.type === "image/png",
        isPDF = file.type === "application/pdf";
      if (!isJPG && !isPNG && !isPDF) {
        this.$message.error("请上传JPG/PNG/PDF文件");
        return false;
      }
    },
    handleRemoveBott(file, fileList) {
      //删除后触发
      this.contract_form.back_file = "";
      fileList.forEach((item) => {
        if (item.response) {
          this.contract_form.back_file += item.response.data + ",";
        } else {
          this.contract_form.back_file += item.url + ",";
        }
      });
    },
    sucUploadBott(response) {
      this.contract_form.back_file += response.data + ",";
    },

    // 提交签约后回调
    subComplete() {
      this.baseInfoVisible = false;
      utils.notificationInfo("提示", "签约申请已提交", "success");
      // 更新
      this.updateDataTag = !this.updateDataTag;
      this.resetPageNum = false;
    },

    //  打开客户指派对话框
    openAssignDia(data) {
      Object.keys(this.assignForm).forEach((key) => {
        this.assignForm[key] = "";
      });
      // this.assignForm.id = Number(data.id)
      this.assignForm.id = data.customer_id;

      this.assignForm.work_order_id = data.work_order_id;

      this.assignForm.name = data.corporate_name;

      this.assignVisible = true;
      if (
        data.assign_id_leader != "" &&
        data.assign_id_leader != null &&
        data.assign_id_leader != "null"
      ) {
        // 组长
        this.assignForm.assign_id_leader = data.assign_id_leader;
      }
      if (
        data.assign_id != "" &&
        data.assign_id != null &&
        data.assign_id != "null"
      ) {
        this.assignForm.assign_id = data.assign_id;
      }
      if (data.assign_id_supervisor) {
        this.assignForm.assign_id_supervisor = data.assign_id_supervisor;
      }
    },
    //  客户指派操作
    assignHandle(fN) {
      // 表单验证
      this.$refs[fN].validate((valid) => {
        if (valid) {
          let paramObj = this.assignForm;
          paramObj.up_user = this.userId;
          paramObj.state = "1"; //指派状态 1 已指派

          api
            .customerAssign(paramObj)
            .then((res) => {
              // console.log('小记返回值',res)
              utils.notificationInfo("提示", "指派成功", "success");
              // 主动更新数据标记---更新
              this.updateDataTag = !this.updateDataTag;
              this.resetPageNum = false;
              // 重置表单
              this.$refs[fN].resetFields();
              this.assignVisible = false;
            })
            .catch((err) => {
              console.log(err);
              utils.notificationInfo("提示", "指派失败", "error");
              this.assignVisible = false;
            });
        } else {
          // console.log('error submit!!');
          utils.notificationInfo("提示", "操作失败", "error");
          return false;
        }
      });
    },
    // 关闭对话框前触发
    assignClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },

    //
    //  新建小记对话框,
    //
    addClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    // 开启对话框
    openDialog(scope, view) {
      // console.log("沟通小记",scope,this.userName)
      this.dialogVisible = view;
      this.touchForm.name = scope.corporate_name; //公司名
      this.touchForm.id = scope.id;
      this.touchForm.user_name = this.userName;
    },
    //确认新建
    addTouchInfo(formName) {
      // 表单验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dialogVisible = false;
          let paramObj = {
            e_id: this.touchForm.id,
            user_id: this.userId,
            communicate_record: this.touchForm.contact_Records,
            communication_mode: this.touchForm.contact_meth,
            remarks: this.touchForm.remarks,
            to_examine: this.touchForm.to_examine,
            complaint: this.touchForm.complaint,
          };
          api
            .addTouchInfo(paramObj)
            .then((res) => {
              // console.log('小记返回值',res)
              utils.notificationInfo("提示", "新建成功", "success");
              // 主动更新数据标记---更新
              this.updateDataTag = !this.updateDataTag;
              this.resetPageNum = false;
              // 重置表单
              this.$refs[formName].resetFields();
            })
            .catch((err) => {
              console.log(err);
              utils.notificationInfo("提示", "新建失败", "error");
            });
        } else {
          // console.log('error submit!!');
          utils.notificationInfo("提示", "新建失败", "error");
          return false;
        }
      });
    },

    //  添加波罗蜜
    // 点击 波罗蜜的修改图标
    remarkEditClick(index) {
      for (let i = 0; i < this.dataList.length; i++) {
        this.dataList[i].boluomiVisible = false;
      }
      this.dataList[index].boluomiVisible = true;
    },
    // 修改波罗蜜
    remarkEditConfirm(row, index) {
      // console.log(row)
      let paramObj = {
        id: row.id,
        boluomi: row.boluomi,
      };

      // boluomi 输入为空时，传递过去只能是 0
      if (row.boluomi == "") {
        paramObj.boluomi = 0;
      }
      // api
      api
        .reviseBoluomi(paramObj)
        .then((res) => {
          // console.log(res)
          this.dataList[index].boluomiVisible = false;
          this.updateDataTag = !this.updateDataTag;
          this.resetPageNum = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //跳转详情页
    // 弃用
    goToDetail(row) {
      if (this.getTabData.is_Purchase) {
        return;
      }
      // console.log('detail',row)
      let r = this.$router.resolve({
        path: "/index/customerManage/customerInfoDetail",
        query: {
          orderId: row.customer_id,
          corporate_name: row.corporate_name, //公司名
          sign: 1, // 特批客户标标识
        },
      });
      window.open(r.href, "_blank");
    },
    handleDetail(row) {
      // 购买人员 只读
      if (this.getTabData.is_Purchase) {
        return;
      }
      this.detailConfig.showSign++;
      this.detailConfig.contractProp = {
        sign: 1, // 进入详情类型标识  // 提前对接客户
        ...row,
      };
    },
    //带条件查询，查询按钮事件
    searchBtn(e) {
      if (e == "contact" && this.valueDate && this.valueDate.length > 0) {
        this.getTabData.start = this.valueDate[0];
        this.getTabData.end = moment(this.valueDate[1])
          .endOf("month")
          .format("yyyy-MM-DD");
      } else {
        this.getTabData.start = "";
        this.getTabData.end = "";
      }
      if (e == "due" && this.dqsjDate) {
        this.getTabData.due_time_start = this.dqsjDate[0];
        this.getTabData.due_time_end = moment(this.dqsjDate[1])
          .endOf("month")
          .format("yyyy-MM-DD");
      } else {
        this.getTabData.due_time_start = "";
        this.getTabData.due_time_end = "";
      }

      utils.debounceFunc(() => {
        utils.sessionSetStore("trialCustomSearch", this.getTabData);
        this.updateDataTag = !this.updateDataTag;
      });
    },

    //重置查询
    resetSearch() {
      this.valueDate = [];
      this.dqsjDate = [];
      Object.keys(this.getTabData).forEach((key) => {
        this.getTabData[key] = "";
      });
      this.getTabData.id = this.userId;
      utils.sessionRemoveStore("trialCustomSearch");
      this.updateDataTag = !this.updateDataTag;
    },

    //表格数据获取
    dataQueryFunc() {
      //查询条件
      let paramObj = {};
      Object.keys(this.getTabData).forEach((key) => {
        if (this.getTabData[key]) {
          paramObj[key] = this.getTabData[key];
        }
      });
      paramObj.is_contract = 2;
      return {
        apiName: "getCustomersData",
        paramObj: paramObj,
        success: function(response, callBack) {
          this.zje = response.data.data.contract_amount_Count;
          this.zsl = response.data.data.totalCount;

          // 表格组件中，调用接口后的成功回调中调用该方法
          let records = response.data.data.list;
          let arr = [];
          for (let i = 0; i < records.length; i++) {
            let obj = records[i];

            Object.keys(obj).forEach((key) => {
              if (obj[key] == null || obj[key] == undefined) {
                obj[key] = "";
              }
            });

            // 相关销售姓名转换
            obj.viewable_name = [];
            if (obj.viewable_person) {
              obj.viewable_person = obj.viewable_person.split(","); // 转为数组
              obj.viewable_person.forEach((userID) => {
                obj.viewable_name.push(this.$tools.conversionName(userID));
              });
            }

            //公司名称选项-----名称过多，弃用-----2020——10——26
            let addName = true; //是否添加公司名
            this.cnOption.forEach((item) => {
              if (item.label == records[i].corporate_name) {
                addName = false;
              }
            });
            if (addName) {
              this.cnOption.push({
                value: records[i].corporate_name,
                label: records[i].corporate_name,
              });
            }

            obj.boluomiVisible = false; // 添加波罗蜜的小框默认不显示

            arr.push(obj);
          }
          // 数据列表---更新
          this.dataList = arr;
          // 数据总条数---更新
          this.totalCount = response.data.data.totalCount; //接口返回的数据总条数

          // 回调函数
          if (callBack) {
            callBack();
          }
        }.bind(this),
        failed: function(error, callBack) {
          // 回调函数
          if (callBack) {
            callBack();
          }
        },
      };
    },
  },
  created() {
    //获取用户id
    this.userId = utils.sessionGetStore("user_id");
    this.userName = utils.sessionGetStore("user_name");
    this.getTabData.id = this.userId;

    // 获取权限
    let jur = utils.sessionGetStore("jurisdiction");
    this.jurisdiction =
      jur == "0" &&
      (this.userId == 1 || this.userId == 2 || this.department == "7")
        ? true
        : false;

    // 获取存在本地的查询条件
    let customSearch = JSON.parse(utils.sessionGetStore("trialCustomSearch"));
    // console.log(customSearch)
    if (customSearch) {
      this.getTabData = customSearch;
      this.valueDate = [this.getTabData.start, this.getTabData.end];
      this.dqsjDate = [
        this.getTabData.due_time_start,
        this.getTabData.due_time_end,
      ];
    }
  },
};
</script>

<style lang="scss" scoped>
.threeLevelMain {
  .queryBox {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    position: relative;

    // 实际服务金额
    .cooperation_amount {
      display: flex;
      align-items: center;
      justify-content: center;
      > div {
        margin: 0 !important;
      }
    }
    .activeBtn {
      position: absolute;
      top: 15px;
      right: 50px;
    }
  }
  .account-view {
    padding: 5px;
    background-color: #fff;
    display: flex;

    .ac-result {
      margin: 0 20px;
      > span {
        font-size: 14px;
      }
      .label {
        line-height: 1;
      }
      &:nth-child(2) {
        margin-left: 50px;
      }
      .cn_num {
        // color: #00B791;
        color: #0f70ee;
        font-weight: bold;
      }
    }
  }
  .totalAmount {
    position: absolute;
    width: 300px;
    // background: red;
    bottom: 25px;
    right: 20px;

    > p {
      font-size: 16px;
      font-weight: 500;
      > span {
        font-size: 16px;
        color: #409eff;
      }
    }
  }
}

.demo-ruleForm {
  > h3 {
    font-size: 16px;
    text-align: center;
    padding: 20px 0;
    color: #409eff;
    letter-spacing: 1px;
  }
  > div {
    padding: 20px;
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
    .formItems {
      width: 30%;
    }
  }
}
</style>
